import React, { Fragment, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import { Form, InputNumber, Row, Col, Divider, Space, Button } from 'antd'
import { toast } from 'react-toastify'
import TitleBar from '../../../components/Elements/TitleBar'
import PatternNumber from '../../../utils/PatternNumber'
import PrefixService from "../../../services/prefix"
import { requestAuthInit } from '../../../store/auth/auth.actions'
import { NewRegBonusConfig } from '../../../@types/prefix'
import { ThunkDispatch } from '../../../@types/store'
import FormattedMessage from '../../../components/Elements/FormattedMessage'
import { FuncFormattedMessage } from '../../../utils/FuncFormattedMessage'

const PromotionCredit = () => {

    const [btnLoading, setBtnLoading] = useState<boolean>(false)
    const [form] = Form.useForm();
    const dispatch: ThunkDispatch<AnyAction> = useDispatch()

    const updateData = async (values: NewRegBonusConfig) => {
        try {
            const res = await PrefixService.saveNewRegBonus(values)
            dispatch(requestAuthInit(false))
            toast.success(res.message)
            setBtnLoading(false)
        } catch ({ message }) {
            toast.error(message as string)
            setBtnLoading(false)
        }
    }

    const handleFormSubmit = async () => {
        form.validateFields()
            .then((values: NewRegBonusConfig) => {
                setBtnLoading(true)
                values.amount = parseFloat(values.amount.toString())
                values.turn = parseFloat(values.turn.toString())
                values.maxWithdraw = parseFloat(values.maxWithdraw.toString())
                updateData(values)
            })
            .catch((errorInfo) => {

            });
    };

    const [dataNewMemberCredit, setDataNewMemberCredit] = useState<any>()
    const fetchNewRegBonus = async () => {
        try {
            const res = await PrefixService.getNewRegBonus()
            setDataNewMemberCredit(res)
        } catch ({ message }) {
            toast.error(message as string)
        }
    }

    useEffect(() => {
        fetchNewRegBonus()
    }, [])

    useEffect(() => {
        if (form && dataNewMemberCredit) {
            form.resetFields();
            form.setFieldsValue(dataNewMemberCredit)
        }
    }, [form, dataNewMemberCredit]);

    const text_amount = FuncFormattedMessage("pro_credit.amount", "จำนวน")
    const text_turn_times = FuncFormattedMessage("turn-times", "เทิร์น (เท่า)")
    const text_maxWithdrawAmount_times = FuncFormattedMessage("pro_credit.maxWithdrawAmount_times", "ยอดถอนสูงสุด (เท่า)")

    return (
        <Fragment>
            <TitleBar title={<FormattedMessage id="pro_credit.title" defaultMessage="ตั้งค่าเครดิตฟรีสำหรับสมาชิกใหม่" />} />
            <div className="box-white ant-box-card">
                <Form
                    form={form}
                    name="creditForm"
                    layout="vertical"
                    hideRequiredMark
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="amount"
                                label={text_amount}
                                rules={[
                                    { required: true, message: <FormattedMessage id="pro_credit.please_amount" defaultMessage="กรุณากรอกจำนวน" /> },
                                    { pattern: PatternNumber, message: <FormattedMessage id="please-enter-numbers-only" defaultMessage="กรุณากรอกเป็นตัวเลขเท่านั้น" /> }
                                ]}
                                hasFeedback>
                                <InputNumber placeholder={text_amount} inputMode="numeric" controls={false} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="turn"
                                label={text_turn_times}
                                rules={[
                                    { required: true, message: <FormattedMessage id="please-enter-turn-times" defaultMessage="กรุณากรอกเทิร์น (เท่า)" /> },
                                    { pattern: PatternNumber, message: <FormattedMessage id="please-enter-numbers-only" defaultMessage="กรุณากรอกเป็นตัวเลขเท่านั้น" /> }
                                ]}
                                hasFeedback>
                                <InputNumber placeholder={text_turn_times} inputMode="numeric" controls={false} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="maxWithdraw"
                                label={text_maxWithdrawAmount_times}
                                rules={[
                                    { required: true, message: <FormattedMessage id="please_maxWithdrawAmount_times" defaultMessage="กรุณากรอกยอดถอนสูงสุด (เท่า)" /> },
                                    { pattern: PatternNumber, message: <FormattedMessage id="please-enter-numbers-only" defaultMessage="กรุณากรอกเป็นตัวเลขเท่านั้น" /> }
                                ]}
                                hasFeedback>
                                <InputNumber placeholder={text_maxWithdrawAmount_times} inputMode="numeric" controls={false} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <div className="drawer-actions">
                        <Space>
                            <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large">
                                <i className="fa-solid fa-save me-2"></i> <FormattedMessage id="save" defaultMessage="บันทึก" />
                            </Button>
                        </Space>
                    </div>
                </Form>
            </div>
        </Fragment>
    )
}

export default PromotionCredit